import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'enumKey' })
export class EnumKeyPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {
    }

    transform(value: any): any {
        const keys: any[] = [];
        for (const enumMember in value) {
            if (value.hasOwnProperty(enumMember)) {
                const isValueProperty = parseInt(enumMember, 10) >= 0;
                if (isValueProperty) {
                    keys.push({ key: +enumMember, value: this.translateService.instant(value[enumMember]) });
                }
            }
        }
        return keys;
    }
}